module.exports = __webpack_public_path__ + "img/sankaku_60_blue.2fb03e52.png";